import {
  Injectable,
  Inject,
  PLATFORM_ID,
  Renderer2,
  RendererFactory2,
} from '@angular/core';
// const slugify = require('@sindresorhus/slugify');
import * as slugify from '@sindresorhus/slugify';
import { addHours,differenceInCalendarDays } from 'date-fns';
import { HttpParams } from '@angular/common/http';
import * as isObjectLike from 'lodash.isobjectlike';
// import * as moment from 'moment-timezone';
const moment =  require('moment-timezone');
import { isPlatformBrowser } from '@angular/common';
import { of } from 'rxjs/internal/observable/of';
import { delay } from 'rxjs/internal/operators/delay';
import { first } from 'rxjs/internal/operators/first';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';

declare var google: any;
// declare var moment: any; 
@Injectable()
export class MiscHelperService {
  private renderer: Renderer2;
  private SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private rendererFactory: RendererFactory2,
    private message: NzMessageService
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public isOffer = new BehaviorSubject<String>('all_offer');
 

  // This Function was created for converting input to  'currency' directive.

  replaceNumberToCurrency(event) {
    let newVal = event.replace(/\D/g, '');
    let response;
    const rawValue = newVal;
    // don't show braces for empty value
    if (newVal.length == 0) {
      newVal = '';
    }
    // don't show braces for empty groups at the end
    else {
      while (newVal.charAt(0) == '0') {
        newVal = newVal.substr(1);
      }

      newVal = newVal.replace(/[^\d.\',']/g, '');

      const point = newVal.indexOf('.');
      if (point >= 0) {
        newVal = newVal.slice(0, point + 3);
      }

      const decimalSplit = newVal.split('.');
      let intPart = decimalSplit[0];
      let decPart = decimalSplit[1];

      intPart = intPart.replace(/[^\d]/g, '');
      if (intPart.length > 3) {
        let intDiv = Math.floor(intPart.length / 3);
        while (intDiv > 0) {
          let lastComma = intPart.indexOf(',');
          if (lastComma < 0) {
            lastComma = intPart.length;
          }

          if (lastComma - 3 > 0) {
            intPart = intPart.splice(lastComma - 3, 0, ',');
          }
          intDiv--;
        }
      }

      if (decPart === undefined) {
        decPart = '';
      } else {
        decPart = '.' + decPart;
      }
      response = intPart + decPart;
    }
    return response;
  }
 

  replaceCommaFromString(input) {
    // add test for NULL
    if (Number.isInteger(input) || input === null) {
      return input;
    } else {
      const result = input.toString().replace(/,/g, '');
      return parseFloat(result);
    }
  }

  // create a slug of title and appends ID
  slugifyUrl(title: string, id: string): string {
    if (title && id) {
      const slug = slugify(title);

      // return slug + '-' + id;
      return slug + '-' + id;
    } else {
      return '';
    }
  }

  // returns string after two dashes (--)
  deSlugifyUrl(url) {
    return url.substring(url.lastIndexOf('-') + 1);
    // return url.split('-')[1];
  }

  markForRef() {
    this.setTimeoutCustom(() => {}, 0);
  }

  // this function takes in date and timezone and returns the date converted to that timezone
  formatBasedOnTimeZone(date, timezone) {
    const output = date.toLocaleString('en-US', {
      timeZone: timezone,
    });
    return output;
  }
  returnDateOffset(date) {
    const my_date = new Date(date);
    const offset = my_date.getTimezoneOffset();

    return offset;
  }
  returnDateAfterOffset(date) {
    const my_date = new Date(date);
    const offset = my_date.getTimezoneOffset();

    return addHours(my_date, offset / 60);
  }

  returnDateAfterOffsetOpposite(date) {
    const my_date = new Date(date);
    let offset = my_date.getTimezoneOffset();

    offset *= -1;
    return addHours(my_date, offset / 60);
  }

  getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
        },
        (err) => {
          reject(err);
        },
        {
          enableHighAccuracy: true,
        }
      );
    });
  }

  getMapsURL(location_obj) {
    const { lat, lng } = location_obj;
    return `https://www.google.com/maps/search/?api=1&map_action=map&query=${lat},${lng}`;
  }

  returnAddressPlacesObject(place) {
    let postal_code, street, state, country, county, neighborhood, city;

    if (place.address_components) {
      for (let x = 0; x < place.address_components.length; x++) {
        if (place.address_components[x].types.includes('route')) {
          street = place.address_components[x].long_name;
        }

        if (
          place.address_components[x].types.includes('locality')
          // ||
          // place.address_components[x].types.includes(
          //   'administrative_area_level_3'
          // )
        ) {
          city = place.address_components[x].long_name;
        }

        if (
          place.address_components[x].types.includes(
            'administrative_area_level_1'
          )
        ) {
          state = place.address_components[x].long_name;
        }

        if (
          place.address_components[x].types.includes(
            'administrative_area_level_2'
          )
        ) {
          county = place.address_components[x].long_name;
        }

        if (place.address_components[x].types.includes('country')) {
          country = place.address_components[x].long_name;
        }

        if (place.address_components[x].types.includes('neighborhood')) {
          neighborhood = place.address_components[x].long_name;
        }

        if (place.address_components[x].types.includes('postal_code')) {
          postal_code = place.address_components[x].long_name;
        }
      }
      const result = {
        address: place.formatted_address,
        location: {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
        street: street,
        country: country,
        neighborhood: neighborhood,
        state: state,
        parish: county,
        postal_code: postal_code,
        city: city,
      };

      return result;
    }
  }
  returnAddressObj(place, loc) {
    let postal_code, street, state, country, county, neighborhood, city;
    let arr = place.split(',');
    for (let x = 0; x < arr.length; x++) {
      if (x == 0) {
        street = arr[x];
      }
      if (x == 1) {
        city = arr[x];
      }
      if (x == 2) {
        state = arr[x];
      }
      if (x == 3) {
        country = arr[x];
      }
    }
    const result = {
      address: place,
      location: loc,
      street: street,
      country: country,
      state: state,
      city: city,
    };

    return result;
  }

  // returnAddressObj(place, loc) {
  //   let postal_code, street, state, country, county, neighborhood, city;
  //   let arr = place.split(',');
  //   for (let x = 0; x < arr.length; x++) {
  //     if(x==0){
  //       street = arr[x];
  //     }
  //     if(x==1){
  //       city = arr[x];
  //     }
  //     if(x==2){
  //       state = arr[x];
  //     }
  //     if(x==3){
  //       country = arr[x];
  //     }
  //   }
  //   const result = {
  //       address: place,
  //       location: loc,
  //       street: street,
  //       country: country,
  //       state: state,
  //       city: city
  //     };

  //     return result;
  // }

  async copySomething(text) {
    if (isPlatformBrowser(this.platformId)) {
      {
        const selBox = document.createElement('textarea');

        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = text;

        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();

        document.execCommand('copy');
        document.body.removeChild(selBox);
      }
    }
  }
  generateAddressUrl(tempUrl: string, address: string, listing_id: string) {
    let splitVal = '.com';

    // check if URL includes .tech

    const tech = tempUrl.includes('.tech');

    if (tech) {
      splitVal = '.tech';
    }

    const res = tempUrl.split(splitVal);
    let url;
    if (res.length) {
      const slugUrl = this.slugifyUrl(address, listing_id);
      url = `${res[0]}${splitVal}/listings/${slugUrl}`;
    }

    return url;
  }

  // this adds scroll class to the top .cdk-global-scrollblock

  addTopClassToHtml() {
    if (isPlatformBrowser(this.platformId)) {
      // reason why document instead of elementRef is because Angualr
      const val = document.getElementsByClassName('htmltop')[0];
      if (val) {
        this.renderer.addClass(val, 'cdk-global-scrollblock');
      }
    }
  }

  // removes class .cdk-global-scrollblock which enables scroll
  removeTopClassToHtml() {
    if (isPlatformBrowser(this.platformId)) {
      // reason why document instead of elementRef is because Angualr
      const val = document.getElementsByClassName('htmltop')[0];
      if (val) {
        this.renderer.removeClass(val, 'cdk-global-scrollblock');
      }
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  objectToHttpParams(obj: any) {
    return Object.entries(obj || {}).reduce((params, [key, value]) => {
      if (value === undefined || value === null) {
        value = '';
      }
      return params.set(
        key,
        isObjectLike(value) ? JSON.stringify(value) : String(value)
      );
      // }
    }, new HttpParams());
  }

  formatMoney(amount, decimalCount = 2, decimal = '.', thousands = ',') {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? '-' : '';

      let i: any = parseInt(
        (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
      ).toString();
      let j = i.length > 3 ? i.length % 3 : 0;

      return (
        negativeSign +
        (j ? i.substr(0, j) + thousands : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
        (decimalCount
          ? decimal +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
          : '')
      );
    } catch (error) {
      console.log('error', error);
    }
  }

  abbreviateNumber(number) {
    // what tier? (determines SI symbol)
    var tier = (Math.log10(Math.abs(number)) / 3) | 0;

    // if zero, we don't need a suffix
    if (tier == 0) return number;

    // get suffix and determine scale
    var suffix = this.SI_SYMBOL[tier];
    var scale = Math.pow(10, tier * 3);

    // scale the number
    var scaled = number / scale;

    // format number and add suffix
    return parseFloat(scaled.toFixed(1)) + suffix;
  }

  returnHoursDifference(timezone) {
    const now = moment();
    now.tz(timezone); // your time zone, not necessarily the server's
    const centralOffset = now.utcOffset();
    return centralOffset / 60;
  }
  getDateFromTimestamp(timestamp) {
    return moment(timestamp).format('YYYY-MM-DD');
  }

  addHoursToDate(date, hours) {
    return addHours(date, hours);
  }

  returnTimeAfterTimezone(date: Date, timezone) {
    const hours_difference = this.returnHoursDifference(timezone);
    return this.addHoursToDate(date, hours_difference);
  }
  validateAllImages(images) {
    for (const image of images) {
      const allowedExt = ['image/png', 'image/jpeg', 'image/jpg'];
      const type = image.type;
      if (allowedExt.includes(type)) {
        continue;
      } else {
        return false;
      }
    }
    return true;
  }
  validateImageSize(images) {

    for (const image of images) {      
      const size = image.size / 1024 / 1024;
      if (size > 10) {
        this.message.error('File Size must be less than 10MB', {
          nzDuration: 4500,
        });
        return false;
      }


    }
    return true;
  }

  validateImageFormat(images) {

    let allowedExt = ['image/jpeg', 'image/png']; 
    // 'image/png',
    let isallowd = false;

    for (const image of images) {    
      const type = image.type;

      allowedExt.forEach(x => {
        if (x === type) {
          isallowd = true;
          return;
        }
      });
  
      if (isallowd == false) {
        this.message.error('File Type not supported, Only jpeg,png,heic are allowed', {
          nzDuration: 4500
        });
        return false;
      } 

    }
    return true;
  }

  getNameLetters(name: string) {
    let letter = '';

    name
      ?.trim()
      ?.split(' ')
      ?.forEach((l) => (letter = letter + l.charAt(0).toUpperCase()));
    return letter.substring(0, 2);
    // return letter;
  }
  getLastYearsRange(range_start) {
    return Array(
      new Date().getUTCFullYear() - (new Date().getUTCFullYear() - range_start)
    )
      .fill('')
      .map((v, idx) => new Date().getUTCFullYear() - idx);
  }
  //Custom timeout for performance purpose
  setTimeoutCustom(cb: () => void, timer: number) {
    of(true).pipe(delay(timer), first()).subscribe(cb);
  }
  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, new Date()) < 0;
  };
  disabledDateAfter = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(new Date(), current) < 0;
  };
  disabledHours(): number[] {
    let current_hour = new Date().getHours();
    let arr = new Array(current_hour).fill(0).map((_, i) => i + 1);
    arr.unshift(0);
    return arr;
  }
  disabledMinutes(): number[] {
    let current_hour = new Date().getMinutes();
    let arr = new Array(current_hour).fill(0).map((_, i) => i + 1);
    arr.unshift(0);
    return arr;
  }
  processFile(imageInput) {
    if (imageInput.files[0]) {
      const file: File = imageInput.files[0];
      var pattern = /image-*/;

      if (!file.type.match(pattern)) {
        alert('Invalid format');
        return false;
      } else {
        return true;
      }
      // here you can do whatever you want with your image. Now you are sure that it is an image
    }
  }
  openChangeSelectScrollIssueHandler(e) {
    setTimeout(() => {
      const delcdkOverlayConnectedPositionBoundingBox = document.querySelector(
        '.cdk-overlay-connected-position-bounding-box'
      );
      if (delcdkOverlayConnectedPositionBoundingBox) {
        if (!e) {
          delcdkOverlayConnectedPositionBoundingBox['style'].display = 'none';
        } else {
          delcdkOverlayConnectedPositionBoundingBox['style'].display = 'block';
        }
      }
    }, 50);
  }

  handleDropdownState(isOpen: boolean): void {
    if (isOpen) {
      this.renderer.addClass(document.body, 'disable-scroll');
    } else {
      this.renderer.removeClass(document.body, 'disable-scroll');
    }
  }
  
  base64ToFile(base64Image: string): File {
    const byteString = atob(base64Image.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: 'image/jpeg' });
    const file = new File([blob], 'image.jpg', { type: 'image/jpeg' });
    return file;
  }

  formatTime(inputDate: string | Date): string | null {
    const date = new Date(inputDate);
    const isValidDate = !isNaN(date.getTime());
  
    if (isValidDate) {
      return moment(date).format('hh:mm a');
    }
  
    return null;
  }

  // convertTimeStringToDate(timeString) {
  //   const hrs = parseInt(timeString.substring(0, 2));
  //   const mins = parseInt(timeString.substring(3, 5));
  //   const ampm = timeString.substring(6, 8).toUpperCase();

  //   const time = new Date();
  //   if (ampm === 'AM' && hrs === 12) {
  //       time.setHours(0);
  //   } else if (ampm === 'PM' && hrs < 12) {
  //       time.setHours(hrs + 12);
  //   } else {
  //       time.setHours(hrs);
  //   }
  //   time.setMinutes(mins);

  //   return time;
  // }

  convertTimeStringToDate(timeString: string): Date {
    const [timePart, meridianPart] = timeString.trim().split(' '); // e.g., "5:00" and "pm"
    const [hours, minutes] = timePart.split(':').map(Number);
    const ampm = meridianPart.toUpperCase();
  
    const date = new Date();
    let hrs = hours;
  
    if (ampm === 'AM' && hrs === 12) {
      hrs = 0;
    } else if (ampm === 'PM' && hrs < 12) {
      hrs += 12;
    }
  
    date.setHours(hrs);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
  
    return date;
  }
  
}
